import React, { useState } from 'react';
import blog1 from '../blog1.png';
import coeurs from '../coeurs.png';
import {
    FaUser, FaSearch, FaBookmark, FaClock, FaPaperPlane, FaArrowRight, FaEdit, FaThLarge
} from 'react-icons/fa';
import { GoShieldCheck } from 'react-icons/go';
import { AiOutlineHeart } from 'react-icons/ai';
import { MdOutlineLock } from 'react-icons/md';
import { IoPeopleOutline } from 'react-icons/io5';
import { TbMessageHeart } from 'react-icons/tb';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useResponsive } from '../hooks/useResponsive';

import { useAuth } from '../context/AuthContext';
import NavbarAuth from '../components/NavbarAuth';
const Blog = () => {
    const { user } = useAuth();
    const { isSmall, isMobile, isTablet } = useResponsive();
    const [activeCategory, setActiveCategory] = useState('Tous les articles');
    const [emailValue, setEmailValue] = useState('');

    const categories = [
        { label: 'Tous les articles', icon: (active) => <FaThLarge size={isSmall ? 16 : 20} color={active ? 'white' : '#781840'} /> },
        { label: 'Conseils & Rappels', icon: (active) => <GoShieldCheck size={isSmall ? 16 : 20} color={active ? 'white' : '#781840'} /> },
        { label: 'Vie de couple', icon: (active) => <AiOutlineHeart size={isSmall ? 16 : 20} color={active ? 'white' : '#781840'} /> },
        { label: 'Spiritualité', icon: (active) => <MdOutlineLock size={isSmall ? 16 : 20} color={active ? 'white' : '#781840'} /> },
        { label: 'Démarche & Parents', icon: (active) => <IoPeopleOutline size={isSmall ? 16 : 20} color={active ? 'white' : '#781840'} /> },
        { label: 'Témoignages', icon: (active) => <TbMessageHeart size={isSmall ? 16 : 20} color={active ? 'white' : '#781840'} /> },
    ];

    const featuredImg = 'https://images.unsplash.com/photo-1606800052052-a08af7148866?w=600&q=80';

    const recentArticles = [
        { tag: 'Vie de couple', date: '10 mai 2024', title: "La communication bienveillante : clé d'un foyer apaisé", readTime: '6 min de lecture', img: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=400&q=80' },
        { tag: 'Spiritualité', date: '8 mai 2024', title: "L'invocation dans le mariage : un lien avec Allah", readTime: '4 min de lecture', img: 'https://images.unsplash.com/photo-1564769662533-4f00a87b4056?w=400&q=80' },
        { tag: 'Conseils & Rappels', date: '5 mai 2024', title: "Comment préserver la pudeur dans la recherche d'un conjoint ?", readTime: '5 min de lecture', img: 'https://images.unsplash.com/photo-1518049362265-d5b2a6467637?w=400&q=80' },
        { tag: 'Démarche & Parents', date: '3 mai 2024', title: "Le rôle des parents dans une démarche islamique", readTime: '6 min de lecture', img: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?w=400&q=80' },
        { tag: 'Spiritualité', date: '1 mai 2024', title: "Le tawhid au cœur de notre relation", readTime: '4 min de lecture', img: 'https://images.unsplash.com/photo-1542816417-0983c9c9ad53?w=400&q=80' },
        { tag: 'Témoignages', date: '29 avr. 2024', title: "Témoignage : D'une rencontre sincère à un mariage béni", readTime: '7 min de lecture', img: 'https://images.unsplash.com/photo-1529636798458-92182e662485?w=400&q=80' },
    ];

    const sideCategories = [
        { label: 'Conseils & Rappels', count: 24 },
        { label: 'Vie de couple', count: 18 },
        { label: 'Spiritualité', count: 15 },
        { label: 'Démarche & Parents', count: 14 },
        { label: 'Témoignages', count: 12 },
    ];

    const popularArticles = [
        { title: "Les signes d'un bon conjoint en Islam", readTime: '5 min de lecture', img: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=120&q=80' },
        { title: "Les erreurs à éviter dans la recherche d'un conjoint", readTime: '6 min de lecture', img: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=120&q=80' },
        { title: "L'importance de la prière à deux", readTime: '5 min de lecture', img: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=120&q=80' },
    ];

    const tagColors = {
        'Conseils & Rappels': '#c0306a',
        'Vie de couple': '#8b5cf6',
        'Spiritualité': '#0891b2',
        'Démarche & Parents': '#059669',
        'Témoignages': '#d97706',
    };

    return (
        <div style={styles.container}>

            {/* ═══════════ NAVBAR ═══════════ */}
            {user ? <NavbarAuth /> : <Navbar />}

            {/* ═══════════ HERO ═══════════ */}
            <div style={{
                position: 'relative',
                overflow: 'visible',
                marginBottom: isSmall ? '70px' : isMobile ? '60px' : '50px',
            }}>
                <img
                    src={blog1}
                    alt=""
                    style={{
                        width: '100%',
                        height: isSmall ? '220px' : isMobile ? '260px' : isTablet ? '350px' : '430px',
                        objectFit: 'cover',
                        objectPosition: 'center center',
                        display: 'block',
                    }}
                />
                <div style={{ position: 'absolute', inset: 0 }} />
                <div style={{
                    position: 'absolute', top: 0, left: 0, right: 0,
                    bottom: isSmall ? '70px' : isMobile ? '65px' : '80px',
                    zIndex: 2,
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    padding: isSmall ? '0 16px' : isMobile ? '0 20px' : isTablet ? '0 40px' : '0 64px',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '8px' }}>
                        <span style={{ color: 'rgba(255,255,255,0.65)', fontSize: isSmall ? '9px' : '11px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase' }}>BLOG</span>
                        <FaEdit color="rgba(255,255,255,0.65)" size={isSmall ? 9 : 11} />
                    </div>
                    <h1 style={{
                        color: 'white', fontWeight: '700',
                        fontSize: isSmall ? '20px' : isMobile ? '26px' : isTablet ? '34px' : '40px',
                        lineHeight: '1.2', marginBottom: '8px', marginTop: 0,
                        maxWidth: isMobile ? '100%' : '600px',
                    }}>
                        Des conseils pour construire<br />
                        une <span style={{ color: '#E88BB4', whiteSpace: 'nowrap' }}>
                            union bénie
                            <img src={coeurs} alt="" style={{ height: isMobile ? '28px' : '46px', verticalAlign: 'middle', marginLeft: '-6px' }} />
                        </span>
                    </h1>
                    <p style={{
                        color: 'rgba(255,255,255,0.72)',
                        fontSize: isSmall ? '10px' : isMobile ? '11px' : '13px',
                        lineHeight: '1.75', margin: 0,
                        maxWidth: isMobile ? '100%' : '420px',
                        display: isSmall ? 'none' : 'block',
                    }}>
                        Articles, rappels et conseils pour vous accompagner dans votre démarche
                        et vous aider à bâtir un foyer basé sur la foi, la sincérité et la bienveillance.
                    </p>
                </div>

                {/* ── FILTRES à cheval sur le bas du hero ── */}
                <div style={{
                    position: 'absolute',
                    bottom: isSmall ? '-45px' : isMobile ? '-40px' : '-35px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: isSmall ? 'calc(100% - 20px)' : isMobile ? 'calc(100% - 32px)' : 'calc(100% - 80px)',
                    maxWidth: '1200px',
                    zIndex: 10,
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    overflowX: 'auto',
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: isSmall ? 'flex-start' : 'space-around',
                        padding: '4px 8px',
                        minWidth: isSmall ? 'max-content' : 'auto',
                    }}>
                        {categories.map((cat, i) => {
                            const isActive = activeCategory === cat.label;
                            return (
                                <button key={i} onClick={() => setActiveCategory(cat.label)} style={{
                                    padding: isSmall ? '6px 8px' : isMobile ? '8px 10px' : '10px 16px',
                                    border: 'none',
                                    borderRadius: '8px',
                                    backgroundColor: isActive ? '#781840' : 'transparent',
                                    color: isActive ? 'white' : '#555',
                                    fontSize: isSmall ? '9px' : isMobile ? '10px' : '12px',
                                    fontWeight: isActive ? '700' : '500',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '4px',
                                    flexShrink: 0,
                                    fontFamily: 'Arial, sans-serif',
                                    whiteSpace: 'nowrap',
                                    transition: 'all 0.2s',
                                    outline: 'none',
                                    margin: '4px 2px',
                                    boxShadow: isActive ? '0 2px 8px rgba(120,24,64,0.35)' : 'none',
                                }}>
                                    {cat.icon(isActive)}
                                    <span>{cat.label}</span>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* ═══════════ CONTENU PRINCIPAL ═══════════ */}
            <section style={{ backgroundColor: '#faf6f8', padding: isSmall ? '16px 12px' : isMobile ? '20px 16px' : isTablet ? '24px 16px' : '28px 20px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', gap: '24px', flexDirection: isMobile ? 'column' : 'row', alignItems: 'flex-start' }}>

                    {/* ── COLONNE GAUCHE ── */}
                    <div style={{ flex: 1, minWidth: 0 }}>

                        {/* Titre + tri */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
                            <div>
                                <h2 style={{ color: '#1a0010', fontSize: isSmall ? '16px' : isMobile ? '18px' : '20px', fontWeight: '700', margin: 0 }}>Articles récents</h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '5px' }}>
                                    <div style={{ width: '20px', height: '2px', backgroundColor: '#781840' }} />
                                    <div style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: '#781840' }} />
                                    <div style={{ width: '20px', height: '2px', backgroundColor: '#781840' }} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '7px', backgroundColor: 'white', border: '1px solid #eedde6', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer' }}>
                                <span style={{ color: '#555', fontSize: '12px' }}>Les plus récents</span>
                                <span style={{ color: '#c0306a', fontSize: '11px' }}>▼</span>
                            </div>
                        </div>

                        {/* ── ARTICLE À LA UNE ── */}
                        <div style={{
                            backgroundColor: 'white', borderRadius: '14px', overflow: 'hidden',
                            border: '1px solid #eedde6', boxShadow: '0 4px 20px rgba(192,48,106,0.09)',
                            marginBottom: '16px', display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            minHeight: isMobile ? 'auto' : '190px',
                        }}>
                            <div style={{ flex: isMobile ? 'none' : '0 0 210px', height: isMobile ? '150px' : 'auto', position: 'relative' }}>
                                <img src={featuredImg} alt="À la une" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(61,8,32,0.3) 0%, transparent 100%)' }} />
                                <div style={{ position: 'absolute', top: '10px', left: '10px', backgroundColor: '#4a0028', color: 'white', fontSize: '10px', fontWeight: '700', padding: '3px 8px', borderRadius: '5px' }}>
                                    ★ À la une
                                </div>
                            </div>
                            <div style={{ padding: isSmall ? '12px' : isMobile ? '14px' : '18px 22px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', flexWrap: 'wrap' }}>
                                        <span style={{ backgroundColor: '#fde8f0', color: '#c0306a', fontSize: '10px', fontWeight: '700', padding: '2px 8px', borderRadius: '4px' }}>Conseils & Rappels</span>
                                        <span style={{ color: '#bbb', fontSize: '11px' }}>📅 12 mai 2024</span>
                                    </div>
                                    <h3 style={{ color: '#1a0010', fontSize: isSmall ? '14px' : isMobile ? '15px' : '19px', fontWeight: '700', lineHeight: '1.3', marginBottom: '8px', marginTop: 0 }}>
                                        Les bases d'un mariage réussi selon l'Islam
                                    </h3>
                                    <p style={{ color: '#666', fontSize: '12px', lineHeight: '1.75', margin: 0, marginBottom: '12px', display: isSmall ? 'none' : 'block' }}>
                                        Un rappel des principes essentiels pour bâtir une relation solide, pleine de sérénité et de miséricorde.
                                    </p>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                        <div style={{ width: '26px', height: '26px', borderRadius: '50%', backgroundColor: '#1a0010', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            <FaUser size={11} color="white" />
                                        </div>
                                        <span style={{ color: '#555', fontSize: '11px', fontWeight: '600' }}>Zawaj & Tawadud</span>
                                        {!isSmall && <span style={{ color: '#bbb', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '3px' }}><FaClock size={9} /> 5 min de lecture</span>}
                                    </div>
                                    <button style={{ backgroundColor: '#4a0028', color: 'white', border: 'none', borderRadius: '6px', padding: '7px 14px', fontSize: '11px', cursor: 'pointer', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '5px', fontFamily: 'Arial, sans-serif' }}>
                                        Lire l'article <FaArrowRight size={9} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* ── GRILLE 6 ARTICLES ── */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isSmall ? '1fr 1fr' : isMobile ? '1fr 1fr' : isTablet ? '1fr 1fr' : '1fr 1fr 1fr',
                            gap: isSmall ? '10px' : '12px',
                            marginBottom: '20px',
                        }}>
                            {recentArticles.map((article, i) => (
                                <div key={i} style={{
                                    backgroundColor: 'white', borderRadius: '12px', overflow: 'hidden',
                                    border: '1px solid #eedde6', boxShadow: '0 2px 8px rgba(192,48,106,0.05)',
                                    display: 'flex', flexDirection: 'column', cursor: 'pointer',
                                }}>
                                    <div style={{ height: isSmall ? '90px' : '110px', position: 'relative' }}>
                                        <img src={article.img} alt={article.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, transparent 50%, rgba(26,0,16,0.15) 100%)' }} />
                                        <button style={{ position: 'absolute', top: '6px', right: '6px', background: 'rgba(26,0,16,0.4)', border: 'none', borderRadius: '5px', padding: '4px 5px', cursor: 'pointer', display: 'flex' }}>
                                            <FaBookmark size={9} color="white" />
                                        </button>
                                    </div>
                                    <div style={{ padding: isSmall ? '8px' : '10px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px', gap: '4px', flexWrap: 'wrap' }}>
                                                <span style={{ backgroundColor: `${tagColors[article.tag]}18`, color: tagColors[article.tag] || '#c0306a', fontSize: '9px', fontWeight: '700', padding: '2px 6px', borderRadius: '4px', whiteSpace: 'nowrap' }}>
                                                    {article.tag}
                                                </span>
                                                <span style={{ color: '#ccc', fontSize: '9px', display: isSmall ? 'none' : 'block' }}>📅 {article.date}</span>
                                            </div>
                                            <h4 style={{ color: '#1a0010', fontSize: isSmall ? '11px' : '12px', fontWeight: '700', lineHeight: '1.4', marginBottom: '6px', marginTop: 0 }}>
                                                {article.title}
                                            </h4>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <FaClock size={8} color="#bbb" />
                                            <span style={{ color: '#bbb', fontSize: '10px' }}>{article.readTime}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Voir plus */}
                        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                            <button style={{ backgroundColor: 'white', color: '#781840', border: '1.5px solid #eedde6', borderRadius: '10px', padding: '10px 26px', fontSize: '13px', cursor: 'pointer', fontWeight: '600', fontFamily: 'Arial, sans-serif', display: 'inline-flex', alignItems: 'center', gap: '7px', boxShadow: '0 2px 8px rgba(192,48,106,0.07)' }}>
                                Voir plus d'articles <FaArrowRight size={10} />
                            </button>
                        </div>

                        {/* ── NEWSLETTER ── */}
                        <div style={{
                            backgroundColor: 'white', borderRadius: '14px', border: '1px solid #eedde6',
                            padding: isSmall ? '14px 12px' : isMobile ? '18px 14px' : '22px 24px',
                            display: 'flex', flexDirection: isMobile ? 'column' : 'row',
                            alignItems: isMobile ? 'flex-start' : 'center', gap: '16px',
                            boxShadow: '0 4px 20px rgba(192,48,106,0.07)',
                        }}>
                            {!isSmall && (
                                <div style={{ flexShrink: 0 }}>
                                    <div style={{ width: '50px', height: '50px', borderRadius: '50%', background: 'linear-gradient(135deg, #fde8f0, #ffd6e8)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px' }}>
                                        💌
                                    </div>
                                </div>
                            )}
                            <div style={{ flex: 1 }}>
                                <h3 style={{ color: '#1a0010', fontSize: isSmall ? '13px' : isMobile ? '14px' : '16px', fontWeight: '700', marginBottom: '4px', marginTop: 0 }}>
                                    Ne manquez aucun rappel ni conseil utile
                                </h3>
                                <p style={{ color: '#888', fontSize: isSmall ? '11px' : '13px', lineHeight: '1.6', margin: 0 }}>
                                    Abonnez-vous à notre newsletter chaque semaine.
                                </p>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', flexShrink: 0, width: isMobile ? '100%' : 'auto', flexWrap: 'wrap' }}>
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center', flex: isMobile ? 1 : 'none' }}>
                                    <span style={{ position: 'absolute', left: '10px', color: '#ccc', fontSize: '12px' }}>📧</span>
                                    <input
                                        type="email"
                                        placeholder="Votre adresse email"
                                        value={emailValue}
                                        onChange={e => setEmailValue(e.target.value)}
                                        style={{ paddingLeft: '30px', paddingRight: '10px', paddingTop: '9px', paddingBottom: '9px', border: '1px solid #eedde6', borderRadius: '7px', fontSize: '12px', outline: 'none', width: isMobile ? '100%' : '200px', fontFamily: 'Arial, sans-serif', color: '#333' }}
                                    />
                                </div>
                                <button style={{ backgroundColor: '#4a0028', color: 'white', border: 'none', borderRadius: '7px', padding: '9px 16px', fontSize: '13px', cursor: 'pointer', fontWeight: '500', display: 'inline-flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap', fontFamily: 'Arial, sans-serif', justifyContent: 'center' }}>
                                    S'abonner <FaPaperPlane size={11} />
                                </button>
                            </div>
                        </div>
                        <p style={{ color: '#ccc', fontSize: '11px', textAlign: 'center', marginTop: '7px' }}>Pas de spam, désabonnement en 1 clic.</p>
                    </div>

                    {/* ── SIDEBAR DROITE ── */}
                    {!isMobile && (
                        <div style={{ flex: isTablet ? '0 0 240px' : '0 0 280px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

                            {/* Recherche */}
                            <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #eedde6', padding: '16px', boxShadow: '0 2px 8px rgba(192,48,106,0.05)' }}>
                                <h4 style={{ color: '#1a0010', fontSize: '14px', fontWeight: '700', marginBottom: '10px', marginTop: 0 }}>Rechercher un article</h4>
                                <div style={{ display: 'flex', gap: '7px' }}>
                                    <input type="text" placeholder="Recherches..." style={{ flex: 1, padding: '8px 10px', border: '1px solid #eedde6', borderRadius: '7px', fontSize: '12px', outline: 'none', fontFamily: 'Arial, sans-serif', color: '#333' }} />
                                    <button style={{ backgroundColor: '#4a0028', color: 'white', border: 'none', borderRadius: '7px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}>
                                        <FaSearch size={13} />
                                    </button>
                                </div>
                            </div>

                            {/* Catégories */}
                            <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #eedde6', padding: '16px', boxShadow: '0 2px 8px rgba(192,48,106,0.05)' }}>
                                <h4 style={{ color: '#1a0010', fontSize: '14px', fontWeight: '700', marginBottom: '10px', marginTop: 0 }}>Catégories</h4>
                                {sideCategories.map((cat, i) => (
                                    <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 0', borderBottom: i < sideCategories.length - 1 ? '1px solid #fdf0f4' : 'none', cursor: 'pointer' }}>
                                        <span style={{ color: '#444', fontSize: '12px', fontWeight: '500' }}>{cat.label}</span>
                                        <span style={{ backgroundColor: '#fde8f0', color: '#c0306a', fontSize: '10px', fontWeight: '700', padding: '2px 7px', borderRadius: '10px' }}>{cat.count}</span>
                                    </div>
                                ))}
                                <button style={{ marginTop: '10px', backgroundColor: 'transparent', color: '#781840', border: 'none', fontSize: '12px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px', padding: 0, fontFamily: 'Arial, sans-serif' }}>
                                    Voir toutes les catégories <FaArrowRight size={9} />
                                </button>
                            </div>

                            {/* Encart CTA */}
                            <div style={{
                                background: 'linear-gradient(135deg, #3d0820 0%, #781840 100%)',
                                borderRadius: '12px', padding: '18px',
                                boxShadow: '0 4px 20px rgba(192,48,106,0.28)',
                                position: 'relative', overflow: 'hidden',
                            }}>
                                <div style={{ position: 'absolute', bottom: '-10px', right: '-10px', fontSize: '60px', opacity: 0.07, lineHeight: 1 }}>🌸</div>
                                <h4 style={{ color: 'white', fontSize: '13px', fontWeight: '700', marginBottom: '7px', marginTop: 0, lineHeight: '1.5', position: 'relative', zIndex: 1 }}>
                                    Besoin d'un conseil<br />ou d'un accompagnement ?
                                </h4>
                                <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '12px', lineHeight: '1.6', marginBottom: '12px', marginTop: 0, position: 'relative', zIndex: 1 }}>
                                    Nos conseillers sont là pour vous guider avec bienveillance.
                                </p>
                                <button style={{ backgroundColor: '#E88BB4', color: '#1a0010', border: 'none', borderRadius: '7px', padding: '9px 14px', fontSize: '12px', cursor: 'pointer', fontWeight: '700', width: '100%', fontFamily: 'Arial, sans-serif', position: 'relative', zIndex: 1 }}>
                                    Nous contacter →
                                </button>
                            </div>

                            {/* Articles populaires */}
                            <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #eedde6', padding: '16px', boxShadow: '0 2px 8px rgba(192,48,106,0.05)' }}>
                                <h4 style={{ color: '#1a0010', fontSize: '14px', fontWeight: '700', marginBottom: '10px', marginTop: 0 }}>Articles populaires</h4>
                                {popularArticles.map((art, i) => (
                                    <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: i < popularArticles.length - 1 ? '10px' : '0', paddingBottom: i < popularArticles.length - 1 ? '10px' : '0', borderBottom: i < popularArticles.length - 1 ? '1px solid #fdf0f4' : 'none', cursor: 'pointer' }}>
                                        <div style={{ width: '46px', height: '46px', borderRadius: '7px', overflow: 'hidden', flexShrink: 0 }}>
                                            <img src={art.img} alt={art.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                        </div>
                                        <div>
                                            <p style={{ color: '#1a0010', fontSize: '12px', fontWeight: '600', lineHeight: '1.4', margin: '0 0 3px 0' }}>{art.title}</p>
                                            <span style={{ color: '#bbb', fontSize: '10px', display: 'flex', alignItems: 'center', gap: '3px' }}><FaClock size={9} /> {art.readTime}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </section>

            {/* ═══════════ FOOTER ═══════════ */}
            <Footer />
        </div>
    );
};

const styles = {
    container: { fontFamily: 'Arial, sans-serif', overflowX: 'hidden' },
};

export default Blog;
